export default {
  domain: 'dev-4b3kz0p1.us.auth0.com',
  clientId: 'bbs2TotBAp4ph1qzB2B3wMEDXpLZpCic',
  audience: 'https://endpoint.guard',
} as const;
